var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useVerticalExternalTimelineProcessController, } from "../../../useVerticalTimelineProcessController";
import { TimelineDescriptionDotCaseIssuanceCNH } from "./components/TimelineDescriptionDotCaseIssuanceCNH";
import { TimelineDescriptionDotDataCaptureError } from "./components/TimelineDescriptionDotDataCaptureError";
import { TimelineDescriptionDotFinishedDefault } from "./components/TimelineDescriptionDotFinishedDefault";
import { TimelineDescriptionDownloadProcessCover } from "./components/TimelineDescriptionDownloadProcessCover";
export function TimelineDescriptionDotProcess(_a) {
    var _b;
    var data = _a.data, step = _a.step;
    var _c = useVerticalExternalTimelineProcessController({
        data: data,
    }), mustDisplayMessageGotoDetran = _c.mustDisplayMessageGotoDetran, isAttrDateNull = _c.isAttrDateNull, isDateBeforeSecondDate = _c.isDateBeforeSecondDate, findAttributeDateValue = _c.findAttributeDateValue;
    var isProcessPaymentStep = step.key === "dataPagamento";
    var isProcessDateStep = step.key === "dataProcesso";
    var isProcessAuthorizedCNHStep = step.key === "dataHabilitado";
    var isProcessEmissaoCnhStep = step.key === "dataEmissaoCnh";
    var hasCurrentProcessDate = isDateBeforeSecondDate(data.dataProcesso, (_b = findAttributeDateValue(step.key)) !== null && _b !== void 0 ? _b : undefined);
    if (mustDisplayMessageGotoDetran(step.key)) {
        return _jsx(TimelineDescriptionDotDataCaptureError, {});
    }
    if (isProcessPaymentStep && isAttrDateNull(step.key))
        return (_jsx("span", __assign({ className: "text-sm font-medium" }, { children: "Realize o pagamento para seguir com sua solicita\u00E7\u00E3o do processo da CNH." })));
    if (isProcessPaymentStep && !isAttrDateNull(step.key))
        return (_jsxs("div", __assign({ className: "flex flex-col gap-1" }, { children: [_jsx(TimelineDescriptionDotFinishedDefault, { data: data, step: step }), _jsx(TimelineDescriptionDownloadProcessCover, { data: data })] })));
    if (!isProcessDateStep && !hasCurrentProcessDate)
        return _jsx(_Fragment, {});
    if (isAttrDateNull(step.key))
        return _jsx(_Fragment, {});
    if (isProcessAuthorizedCNHStep && !findAttributeDateValue("dataEmissaoCnh")) {
        return (_jsxs(_Fragment, { children: [_jsx(TimelineDescriptionDotFinishedDefault, { data: data, step: step }), _jsx("p", __assign({ className: "text-sm font-medium" }, { children: "Sua CNH est\u00E1 sendo confeccionada pela gr\u00E1fica. Aguarde as pr\u00F3ximas instru\u00E7\u00F5es." }))] }));
    }
    if (isProcessEmissaoCnhStep) {
        return (_jsxs(_Fragment, { children: [_jsx(TimelineDescriptionDotFinishedDefault, { data: data, step: step }), _jsx(TimelineDescriptionDotCaseIssuanceCNH, { data: data })] }));
    }
    return _jsx(TimelineDescriptionDotFinishedDefault, { data: data, step: step });
}
